import FaqLayout from "@/components/feature/FaqLayout";

export default function AutoRenewPage() {
  return (
    <FaqLayout
      breadcrumb="/ Subscription Management"
      title="Does my subscription"
      accent="automatically renew?"
    >
      <div className="space-y-6 text-[#1A1C1E]">
        <h2 className="text-2xl font-bold text-[#1A1C1E]">Automatic Renewal Policy</h2>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Yes, all Trevionix subscriptions are set to automatically renew at the end of each billing cycle unless you manually cancel beforehand. This ensures uninterrupted access to all features and services.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Renewal Timeline</h3>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563]">
          <li><strong>Monthly plans:</strong> Renew on the same calendar date each month. If the date does not exist (e.g., 31st), renewal occurs on the last day of that month.</li>
          <li><strong>Annual plans:</strong> Renew on the anniversary of your original signup date.</li>
          <li>You will receive a renewal reminder email <strong>7 days</strong> before your billing date.</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">How to Turn Off Auto-Renewal</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Disabling auto-renewal is the same as cancelling your subscription. Follow the cancellation steps in your account settings. Your service will continue until the end of the current period, after which it will not renew.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Payment Method Updates</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          If your payment method fails at renewal, we will attempt to charge it again over a 7-day grace period. During this time, your service remains active. If payment cannot be processed, your subscription will be suspended until a valid payment method is added.
        </p>

        <div className="bg-[#F7F5F2] rounded-xl p-6 mt-8">
          <p className="text-sm font-semibold text-[#1A1C1E] mb-2">Manage your renewal settings</p>
          <p className="text-sm text-[#6C7278]">
            Log into your account dashboard to view your next billing date, update payment details, or cancel auto-renewal at any time.
          </p>
        </div>
      </div>
    </FaqLayout>
  );
}